import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './Store/configureStore';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './components/Header/index';
import Footer from './components/footer/index';



const history = createBrowserHistory();
const initialState = {};
const store = configureStore(initialState, history);



ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      
      <Router>
    <div className='super-container'>
    <Header/>
      <App />
      </div>
      </Router>
    </ConnectedRouter>
</Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
